import React from 'react'
import { iWebFormField } from '../schema'
import { Box } from '@mui/material'

const HeaderContent = ({fieldConfig}: {fieldConfig:iWebFormField}) => {
    const {fieldLabel,fieldDescription}=fieldConfig;
    return (
        <Box>
            <p style={{fontSize:'16px'}}><b>{fieldLabel}</b> : {fieldDescription}</p>
        </Box>
    )
}

export default HeaderContent